import { animate, state, style, transition, trigger, keyframes } from '@angular/animations';

export const FLIP_IN_X =
	trigger('flipInX', [
		state('on', style({
            transform: 'perspective(400px)',
            opacity: 1
		})),
		state('off',   style({
            transform: 'perspective(400px) rotate3d(1, 0, 0, 90deg)',
            opacity: 0
		})),
	transition('on => off', animate('1s ease-out')),
      transition('off => on', animate('2s ease-in', keyframes(
		[
			style({transform: 'perspective(400px) rotate3d(1, 0, 0, 90deg)', offset: 0}),
			style({transform: 'perspective(400px) rotate3d(1, 0, 0, -20deg)', opacity: 0.5 , offset: 0.4}),
			style({transform: 'perspective(400px) rotate3d(1, 0, 0, 10deg)', opacity: 1,  offset: 0.60}),
			style({transform: 'perspective(400px) rotate3d(1, 0, 0, -5deg)', opacity: 1,  offset: 0.80}),
			style({transform: 'perspective(400px)', opacity: 1,  offset: 1.0})
		]
	)))
    ]); 

export const FLIP_IN_Y =
	trigger('flipInY', [
		state('on', style({
            transform: 'perspective(400px)',
            opacity: 1
		})),
		state('off',   style({
            transform: 'perspective(400px) rotate3d(0, 1, 0, 90deg)',
            opacity: 0
		})),
	transition('on => off', animate('1s ease-out')),
      transition('off => on', animate('2s ease-in', keyframes(
		[
			style({transform: 'perspective(400px) rotate3d(0, 1, 0, 90deg)', offset: 0}),
			style({transform: 'perspective(400px) rotate3d(0, 1, 0, -20deg)', opacity: 0.5 , offset: 0.4}),
			style({transform: 'perspective(400px) rotate3d(0, 1, 0, 10deg)', opacity: 1,  offset: 0.60}),
			style({transform: 'perspective(400px) rotate3d(0, 1, 0, -5deg)', opacity: 1,  offset: 0.80}),
			style({transform: 'perspective(400px)', opacity: 1,  offset: 1.0})
		]
	)))
    ]); 